import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import {
  Play,
  Camera,
  Calendar,
  Users,
  Award,
  Star,
  ArrowRight,
  CheckCircle,
  Video,
  Mic,
  Image,
  Zap,
} from 'lucide-react'
import SEO from '../components/SEO'
import LocalSEO from '../components/LocalSEO'

const Home = () => {
  const services = [
    {
      icon: Calendar,
      title: 'Event Management',
      description: 'Complete event planning and coordination for memorable experiences.',
      color: 'from-primary-500 to-primary-600',
    },
    {
      icon: Video,
      title: 'Video Production',
      description: 'Professional video production with cutting-edge equipment and expertise.',
      color: 'from-secondary-500 to-secondary-600',
    },
    {
      icon: Users,
      title: 'Corporate Events',
      description: 'Sophisticated corporate event solutions that elevate your brand.',
      color: 'from-accent-500 to-accent-600',
    },
    {
      icon: Camera,
      title: 'Photography',
      description: 'Stunning photography that captures the essence of your special moments.',
      color: 'from-purple-500 to-purple-600',
    },
    {
      icon: Mic,
      title: 'Live Streaming',
      description: 'High-quality live streaming services for global audience reach.',
      color: 'from-pink-500 to-pink-600',
    },
    {
      icon: Image,
      title: 'Wedding Coverage',
      description: 'Comprehensive wedding documentation with artistic flair.',
      color: 'from-indigo-500 to-indigo-600',
    },
  ]

  const stats = [
    { number: '2500+', label: 'Events Completed' },
    { number: '25+', label: 'Years Experience' },
    { number: '1000+', label: 'Happy Clients' },
    { number: '24/7', label: 'Support Available' },
  ]

  const features = [
    'Professional Equipment',
    'Experienced Team',
    'Creative Direction',
    'Post-Production',
    'Quick Turnaround',
    'Quality Service',
  ]

  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Parth Video - Professional Video Production & Event Management Ahmedabad",
    "description": "Parth Video is Ahmedabad's leading professional video production and event management company. We bring your vision to life with creativity, precision, and unmatched quality since 1999.",
    "url": "https://parthvideo.in",
    "mainEntity": {
      "@type": "LocalBusiness",
      "@id": "https://parthvideo.in/#business",
      "name": "Parth Video",
      "alternateName": "Parth Video Production",
      "description": "Leading professional video production, event management, and photography company in Ahmedabad, Gujarat, India. Serving clients since 1999 with corporate events, weddings, live streaming, and commercial video production.",
      "foundingDate": "1999",
      "telephone": "+91-7874467874",
      "email": "bhavesh7874@gmail.com",
      "url": "https://parthvideo.in",
      "logo": "https://parthvideo.in/logo.png",
      "image": "https://parthvideo.in/og-image.jpg",
      "priceRange": "₹₹₹",
      "currenciesAccepted": "INR",
      "paymentAccepted": "Cash, Credit Card, Bank Transfer, UPI",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Ahmedabad",
        "addressLocality": "Ahmedabad",
        "addressRegion": "Gujarat",
        "postalCode": "380001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "23.0225",
        "longitude": "72.5714"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Ahmedabad",
          "containedInPlace": {
            "@type": "State",
            "name": "Gujarat"
          }
        },
        {
          "@type": "State",
          "name": "Gujarat"
        }
      ],
      "serviceType": [
        "Video Production",
        "Event Management",
        "Wedding Videography",
        "Corporate Video Production",
        "Photography Services",
        "Live Streaming",
        "Event Planning",
        "Commercial Video Production"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Video Production & Event Management Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Corporate Video Production",
              "description": "Professional corporate video production services in Ahmedabad"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Wedding Videography",
              "description": "Complete wedding video coverage and photography in Ahmedabad"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Event Management",
              "description": "Full-service event planning and management in Ahmedabad"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Live Streaming Services",
              "description": "Professional live streaming for events and corporate functions"
            }
          }
        ]
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "150",
        "bestRating": "5",
        "worstRating": "1"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Satisfied Client"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "reviewBody": "Excellent video production services in Ahmedabad. Professional team with great attention to detail."
        }
      ],
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Saturday"],
          "opens": "10:00",
          "closes": "16:00"
        }
      ],
      "sameAs": [
        "https://www.facebook.com/parthvideo",
        "https://www.instagram.com/parthvideo",
        "https://www.youtube.com/parthvideo",
        "https://www.linkedin.com/company/parthvideo"
      ],
      "knowsAbout": [
        "Video Production",
        "Event Management",
        "Wedding Photography",
        "Corporate Events",
        "Live Streaming",
        "Commercial Video",
        "Event Planning Ahmedabad",
        "Professional Photography Gujarat"
      ]
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      <SEO
        title="Parth Video - Professional Video Production & Event Management | Ahmedabad"
        description="Parth Video is Ahmedabad's leading professional video production and event management company. We bring your vision to life with creativity, precision, and unmatched quality since 1999."
        keywords="Parth Video, video production Ahmedabad, event management India, corporate video production, wedding videography, live streaming services, professional photography, event planning, video editing, Parth Video Ahmedabad, best video production company"
        canonical="https://parthvideo.in"
        structuredData={homeStructuredData}
      />
      <LocalSEO 
        pageName="Home"
        serviceType="Video Production & Event Management"
        location="Ahmedabad"
      />
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-primary-500/20 rounded-full blur-3xl animate-pulse" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-secondary-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-accent-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }} />
        </div>

        <div className="relative z-10 container-custom section-padding text-center">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
              className="inline-flex items-center space-x-2 glass-nav text-sm font-medium"
            >
              <Award className="w-4 h-4 text-primary-400" />
              <span>Parth Video - Professional Video Production Since 1999</span>
            </motion.div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight">
              <span className="block text-white mb-4">Parth Video</span>
              <span className="block gradient-text">Capturing Perfect Moments</span>
            </h1>

            <p className="text-xl md:text-2xl text-white/80 max-w-3xl mx-auto leading-relaxed">
              Parth Video is Ahmedabad's leading professional video production and event management company. We bring your vision to life with creativity, precision, and unmatched quality since 1999.
            </p>

            <motion.div
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6 }}
              className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6"
            >
              <Link
                to="/booking"
                className="bg-gradient-to-r from-primary-500 to-secondary-500 rounded-full px-8 py-4 text-lg font-semibold transition-all duration-300 hover:scale-105 active:scale-95 shadow-xl hover:shadow-2xl flex items-center space-x-2 group"
              >
                <Calendar className="w-5 h-5" />
                <span>Book Your Event</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
              </Link>
              
              <Link
                to="/gallery"
                className="glass-button flex items-center space-x-2 text-lg group"
              >
                <Play className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" />
                <span>View Our Work</span>
              </Link>
            </motion.div>
          </motion.div>
        </div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        >
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white/60 rounded-full mt-2 animate-bounce" />
          </div>
        </motion.div>
      </section>

      {/* Stats Section */}
      <section className="section-padding bg-black/20">
        <div className="container-custom">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="text-center glass-card hover-lift"
              >
                <div className="text-3xl md:text-4xl font-bold gradient-text mb-2">
                  {stat.number}
                </div>
                <div className="text-white/70 font-medium">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="section-padding">
        <div className="container-custom">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Our <span className="gradient-text">Services</span>
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              From intimate gatherings to grand celebrations, we provide comprehensive solutions for all your video production and event management needs.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const Icon = service.icon
              return (
                <motion.div
                  key={index}
                  initial={{ y: 50, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="glass-card hover-lift hover-glow group cursor-pointer"
                >
                  <div className={`w-16 h-16 rounded-2xl bg-gradient-to-r ${service.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-4 group-hover:text-primary-300 transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-white/70 leading-relaxed">
                    {service.description}
                  </p>
                </motion.div>
              )
            })}
          </div>

          <motion.div
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            className="text-center mt-12"
          >
            <Link
              to="/services"
              className="glass-button inline-flex items-center space-x-2 text-lg group"
            >
              <span>Explore All Services</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="section-padding bg-black/20">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              className="space-y-8"
            >
              <div>
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  Why Choose <span className="gradient-text">Parth Video</span>?
                </h2>
                <p className="text-xl text-white/70 leading-relaxed">
                  With over a decade of experience in the industry, we combine technical expertise with creative vision to deliver exceptional results that exceed expectations.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {features.map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ x: -30, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.1 }}
                    className="flex items-center space-x-3"
                  >
                    <CheckCircle className="w-5 h-5 text-primary-400 flex-shrink-0" />
                    <span className="text-white/80">{feature}</span>
                  </motion.div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                <Link
                  to="/about"
                  className="glass-button inline-flex items-center justify-center space-x-2 group"
                >
                  <span>Learn More About Us</span>
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
                </Link>
                <Link
                  to="/contact"
                  className="bg-gradient-to-r from-secondary-500 to-accent-500 rounded-full px-6 py-3 font-medium transition-all duration-300 hover:scale-105 active:scale-95 shadow-lg text-center"
                >
                  Get Free Quote
                </Link>
              </div>
            </motion.div>

            <motion.div
              initial={{ x: 50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="glass-card p-8 space-y-6">
                <div className="flex items-center space-x-4">
                  <div className="p-3 rounded-full bg-gradient-to-r from-primary-500 to-secondary-500">
                    <Zap className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white">Quick Response</h3>
                    <p className="text-white/60">24-hour response guarantee</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="p-3 rounded-full bg-gradient-to-r from-secondary-500 to-accent-500">
                    <Award className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white">Quality Assured</h3>
                    <p className="text-white/60">100% satisfaction guarantee</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-4">
                  <div className="p-3 rounded-full bg-gradient-to-r from-accent-500 to-purple-500">
                    <Star className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-white">Premium Service</h3>
                    <p className="text-white/60">Personalized attention to detail</p>
                  </div>
                </div>
              </div>
              
              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-primary-500/20 rounded-full blur-xl floating" />
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-secondary-500/20 rounded-full blur-xl floating" style={{ animationDelay: '1s' }} />
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding">
        <div className="container-custom">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            className="glass-card text-center space-y-8 relative overflow-hidden"
          >
            {/* Background decoration */}
            <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 via-secondary-500/10 to-accent-500/10" />
            
            <div className="relative z-10">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Ready to Create Something <span className="gradient-text">Amazing</span>?
              </h2>
              <p className="text-xl text-white/70 max-w-2xl mx-auto mb-8">
                Let's bring your vision to life with our professional video production and event management services.
              </p>
              
              <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
                <Link
                  to="/booking"
                  className="bg-gradient-to-r from-primary-500 to-secondary-500 rounded-full px-8 py-4 text-lg font-semibold transition-all duration-300 hover:scale-105 active:scale-95 shadow-xl hover:shadow-2xl flex items-center space-x-2 group"
                >
                  <Calendar className="w-5 h-5" />
                  <span>Start Your Project</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                </Link>
                
                <Link
                  to="/contact"
                  className="glass-button flex items-center space-x-2 text-lg group"
                >
                  <span>Get Free Consultation</span>
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </motion.div>
  )
}

export default Home